// A helper to for instance delay the handling of request response
// to ensure loading spinners don't flash in and out
export default function delay(time = 500): Promise<any> {
  return new Promise((res) => setTimeout(res, time))
}
